import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import CoachProfilePage from "../pages/coaches/CoachProfilePage";
import ClassesPage from "../pages/seo/ClassesPage";
import MembershipPage from "../pages/seo/MembershipPage";
import PhysiotherapyPage from "../pages/seo/PhysiotherapyPage";
import CoachesPage from "../pages/seo/CoachesPage";
import ContactPage from "../pages/seo/ContactPage";
import SchedulePage from "../pages/seo/SchedulePage";
import AboutPage from "../pages/seo/AboutPage";
import EventsListPage from "../pages/events/EventsListPage";
import EventResultsPage from "../pages/events/EventResultsPage";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  // SEO-crawlable pages — same content as homepage sections, unique meta per route
  {
    path: "/classes",
    element: <ClassesPage />,
  },
  {
    path: "/membership",
    element: <MembershipPage />,
  },
  {
    path: "/physiotherapy",
    element: <PhysiotherapyPage />,
  },
  {
    path: "/coaches",
    element: <CoachesPage />,
  },
  {
    path: "/contact",
    element: <ContactPage />,
  },
  {
    path: "/schedule",
    element: <SchedulePage />,
  },
  {
    path: "/aboutUs",
    element: <AboutPage />,
  },
  // Competition results
  {
    path: "/events",
    element: <EventsListPage />,
  },
  {
    path: "/events/:slug",
    element: <EventResultsPage />,
  },
  // Individual profile pages
  {
    path: "/coaches/:slug",
    element: <CoachProfilePage />,
  },
  {
    path: "/physio/:slug",
    element: <CoachProfilePage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
